<template>
    <div class="settings">
        <design-2021-apprentice-multistep-form-wizard-form-header-component
            :description="description"
            :title="$t('multistep.subproject')">
        </design-2021-apprentice-multistep-form-wizard-form-header-component>

        <b-alert
            v-if="!hasGroups"
            show
            variant="warning">
            {{ $t('multistep.no_groups_found') }}
        </b-alert>

        <b-form-group
            class="sub-project-toggle-group"
            :label="labelText"
            :class="{ disabled: !hasGroups }"
            label-for="project-duplicate-toggle-switch">
            <b-form-checkbox
                v-model="checked"
                name="project-duplication-toggle-button"
                switch
                :disabled="!hasGroups">
            </b-form-checkbox>
        </b-form-group>

        <design-2021-apprentice-picklist-component
            class="groups-picklist"
            v-if="checked && groups.length > 0"
            v-model="getGroups"
            :available-label="$t('multistep.available_groups')"
            :enable-search="true"
            data-key="id"
            :selected-label="$t('multistep.selected_groups')"
            @update="updateSelectedGroups">
        </design-2021-apprentice-picklist-component>

        <design-2021-apprentice-picklist-component
            class="main-group-picklist"
            v-if="checked && mainGroups.length > 0"
            v-model="getMainGroups"
            :available-label="$t('multistep.available_main_groups')"
            :enable-search="true"
            data-key="id"
            :selected-label="$t('multistep.selected_main_groups')"
            @update="updateSelectedMainGroups">
        </design-2021-apprentice-picklist-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-apprentice-multistep-wizard-sub-project-settings-step-component',
    props: {
        value: {
            type: Object,
            required: true,
        },

        selectedSeason: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            settings: this.value,
            description:
                `<span class="description">` + this.$t('multistep.sub_project_explanation_las_groups') + `</span>`,
            labelText: this.$t('multistep.sub_project_description_las_groups'),
            checked: false,
            groups: [],
            mainGroups: [],
        };
    },

    mounted() {
        this.getLasLocations();
    },

    methods: {
        getLasLocations() {
            this.axios.get(this.routes.schoolGetLaslocations()).then(
                (response) => {
                    this.groups = [];
                    if (response.data.groups.length > 0) {
                        this.groups.push(...response.data.groups);
                    }

                    this.mainGroups = [];
                    if (response.data.main_groups.length > 0) {
                        this.mainGroups.push(...response.data.main_groups);
                    }
                },

                () => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateSelectedGroups(groups) {
            this.settings.groups = [...groups];
        },

        updateSelectedMainGroups(mainGroups) {
            this.settings.main_groups = [...mainGroups];
        },

        getMainGroupsOfSelectedSeason() {
            return this.mainGroups.filter((main_group) => main_group.season_id === this.selectedSeason.id);
        },

        getGroupsOfSelectedSeason() {
            return this.groups.filter((group) => group.season_id === this.selectedSeason.id);
        },

        resetSelectedGroups() {
            this.settings.groups = [];
            this.settings.main_groups = [];
        },
    },
    computed: {
        getMainGroups() {
            return this.getMainGroupsOfSelectedSeason();
        },

        getGroups() {
            return this.getGroupsOfSelectedSeason();
        },

        hasGroups() {
            const hasGroups =
                this.getMainGroupsOfSelectedSeason().length > 0 || this.getGroupsOfSelectedSeason().length > 0;

            // Uncheck when no groups for the selected season has been found
            if (this.checked && !hasGroups) {
                this.checked = false;
            }

            return hasGroups;
        },
    },
    watch: {
        selectedSeason() {
            // Unset selected groups and main groups when selected season is changed
            this.resetSelectedGroups();
        },

        checked() {
            // Unset selected groups and main groups checkbox is changed
            this.resetSelectedGroups();
        },
    },
};
</script>

<style lang="scss" scoped>
.sub-project-toggle-group ::v-deep {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: $grid-gutter-width;

    label {
        margin-bottom: 0;
    }
}

.groups-picklist {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
